import {Layout} from "@/components/layout";
import Container from "@/components/ui/container";
import Breadcrumbs from "@/components/breadcrumb";
import {Separator} from "@/components/ui/separator";
import * as React from "react";
import {FormComponent} from "@/components/forms";
import Link from "next/link";
import {FbLogoSvg, XLogoSvg, YtLogoSvg} from "@/components/svg";
import {useMemo} from "react";
import dynamic from "next/dynamic";
import {HeadMetadata} from "@/components/headMetadata";

const contactFormUrl: string = 'contact';

export default function ContactPage () {
  const Map = useMemo(() => dynamic(
    () => import('@/components/map/map'),
    {
      loading: () => <p>Chargement</p>,
      ssr: false
    }
  ), [])

  const breadcrumb = [
    {label: 'Nous contacter'}
  ];

  return (
    <Layout>
      <HeadMetadata
        title="Nous contacter"
        description="Pour toute demande particulière, veuillez remplir ce formulaire de contact."
      />

      <Container className="py-10">
        <Breadcrumbs entries={breadcrumb}/>
        <div>

          <h1 className="mb-2 text-[40px] text-foreground-dark">Nous contacter</h1>
          <p className='text-foreground-light mb-3'>Pour toute demande particulière, veuillez remplir ce formulaire de
            contact</p>
          <Separator className='mb-4'/>

          <div className="flex md:flex-row flex-col-reverse pt-6">
            <div className="flex flex-col md:basis-1/2 text-foreground-dark gap-6 px-4 py-6">
              <div>
                <Map position={{lat: -22.268912, lng:166.443189}} zoom={20} />
              </div>
              {/*While the contact form is hidden move this part in right side of th epage*/}
              {/*<div>*/}
              {/*  <h2 className="text-2xl">Adresse</h2>*/}
              {/*  <p>4 rue de Sébastopol, Nouméa</p>*/}
              {/*  <p><strong>Standard</strong> : 25 46 46</p>*/}
              {/*  <p><strong>Rédaction</strong> : 25 45 00</p>*/}
              {/*  <p><strong>Fax</strong> : 28 49 28</p>*/}
              {/*  <p><strong>E-mail</strong> : rrb@lagoon.nc</p>*/}
              {/*</div>*/}
              {/*<div className="flex flex-col gap-2">*/}
              {/*  <h2 className="text-2xl">Nos réseaux sociaux</h2>*/}
              {/*  <Link href={'https://fr-fr.facebook.com/RadioRythmeBleu/'} target='_blank' className="flex gap-1 hover:underline">*/}
              {/*    <FbLogoSvg/><p>Facebook</p>*/}
              {/*  </Link>*/}
              {/*  <Link href="https://www.youtube.com/channel/UCpJBjs9gx9go13oJrXW4bzQ" target='_blank' className="flex gap-1 hover:underline">*/}
              {/*    <YtLogoSvg/><p>YouTube</p>*/}
              {/*  </Link>*/}
              {/*  <Link href="https://twitter.com/RRB_NC" target='_blank' className="flex gap-1 hover:underline">*/}
              {/*    <XLogoSvg/><p>X / Twitter</p>*/}
              {/*  </Link>*/}
              {/*</div>*/}
            </div>
            <div className="md:basis-1/2">
              {/*Remove because no smtp connection*/}
              <div>
                <h2 className="text-2xl">Adresse</h2>
                <p>4 rue de Sébastopol, Nouméa</p>
                <p><strong>Standard</strong> : 25 46 46</p>
                <p><strong>Rédaction</strong> : 25 45 00</p>
                <p><strong>Fax</strong> : 28 49 28</p>
                <p><strong>E-mail</strong> : rrb@lagoon.nc</p>
              </div>
              <div className="flex flex-col gap-2">
                <h2 className="text-2xl">Nos réseaux sociaux</h2>
                <Link href={'https://fr-fr.facebook.com/RadioRythmeBleu/'} target='_blank'
                      className="flex gap-1 hover:underline">
                  <FbLogoSvg/><p>Facebook</p>
                </Link>
                <Link href="https://www.youtube.com/channel/UCpJBjs9gx9go13oJrXW4bzQ" target='_blank'
                      className="flex gap-1 hover:underline">
                  <YtLogoSvg/><p>YouTube</p>
                </Link>
                <Link href="https://twitter.com/RRB_NC" target='_blank' className="flex gap-1 hover:underline">
                  <XLogoSvg/><p>X / Twitter</p>
                </Link>
              </div>
              {/*<FormComponent formId={'contact'} formTitle="Formulaire de contact"/>*/}
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  )
}
